var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.485 3.534a12.003 12.003 0 0 0-16.97 16.98 12.136 12.136 0 0 0 16.684.277 12.073 12.073 0 0 0 2.47-3.26 11.937 11.937 0 0 0 1.2-3.744c.087-.584.13-1.173.13-1.763a11.931 11.931 0 0 0-3.514-8.49ZM5.292 5.292a9.623 9.623 0 0 1 12.23-1.023.264.264 0 0 1 .03.4L4.668 17.561a.265.265 0 0 1-.4-.031A9.5 9.5 0 0 1 5.292 5.292Zm13.457 13.464a9.518 9.518 0 0 1-12.231 1.023.264.264 0 0 1-.032-.4L19.373 6.486a.265.265 0 0 1 .4.031 9.5 9.5 0 0 1-1.023 12.239h-.001Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export { SvgDelete as ReactComponent };
export default __webpack_public_path__ + "3232506ef490fdf7f28710bb28167134ac6039dbac1e579e08945e23eab4a4e8.svg";